import { RouteComponentProps } from 'react-router-dom';
import { oc } from 'ts-optchain';
import _ from 'lodash';

import { PropsToPass } from 'routes/business/SearchModalRoute';
import { consumer } from '@tock/coretypes';
import { getNextRelease } from 'utils/businessUtils';
import { offeringsSelector } from 'selectors/calendarSelectors';
import BaseComponent from '@tock/shared/components/BaseComponent';
import ExperienceMenuModal from 'components/business/ExperienceMenuModal';
import connect, { DefaultConnectProps, StoreType } from '@tock/shared/utils/connect';

type Props = PropsToPass & RouteComponentProps<MatchParams>;

interface ConnectProps extends DefaultConnectProps {
  calendar: StoreType['calendar'];
  offerings?: consumer.ConsumerOfferings;
}

interface State {
  experienceId?: number;
}

export interface MatchParams {
  experienceId: string;
  ticketTypeAccessToken: string;
}

class ExperienceMenuRoute extends BaseComponent<Props & ConnectProps, State> {
  constructor(props: Props & ConnectProps) {
    super(props);

    const { match } = props;
    let experienceId;

    if (match.params.experienceId) {
      experienceId = _.toNumber(match.params.experienceId);
    }

    this.state = {
      experienceId,
    };
  }

  componentDidMount() {
    const { match } = this.props;
    if (match.params.ticketTypeAccessToken) {
      this.handleLoadExperienceFromAccessTokenSuccess(this.props);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps: Props & ConnectProps) {
    const { calendar, match } = this.props;
    const { calendar: nextCalendar } = nextProps;
    if (match.params.ticketTypeAccessToken && !calendar.calendar && nextCalendar.calendar) {
      this.handleLoadExperienceFromAccessTokenSuccess(nextProps);
    }
  }

  handleLoadExperienceFromAccessTokenSuccess(props: Props & ConnectProps) {
    const { match } = this.props;
    const ticketType = _.find(oc(props.calendar).calendar.ticketType(), (ticketType) => {
      return ticketType.privateAccessToken === match.params.ticketTypeAccessToken;
    });
    if (ticketType) {
      this.setState({
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        experienceId: ticketType.id!,
      });
    }
  }

  render() {
    const {
      app,
      app: { config, jwtToken, patron },
      calendar,
      offerings,
      isWidget,
      onClose,
    } = this.props;
    const business = config?.business;

    const { experienceId } = this.state;

    const isAuthenticated = !!jwtToken;
    const nextRelease = getNextRelease(app.config);

    return (
      <ExperienceMenuModal
        business={business as consumer.BusinessConfig}
        calendar={calendar}
        offerings={offerings}
        experienceId={experienceId}
        isAuthenticated={isAuthenticated}
        isWidget={isWidget}
        isRoute={true}
        isOpen={true}
        key="modal"
        nextRelease={nextRelease}
        onClose={onClose}
        patron={patron || undefined}
      />
    );
  }
}

const mapStateToProps = (state: StoreType) => ({
  calendar: state.calendar,
  offerings: offeringsSelector(state),
});

export default connect<Props, ConnectProps>(ExperienceMenuRoute, mapStateToProps);
